import styled from 'styled-components';

import { MAX_WIDTH_MOBILE } from '@utils';

import { Colors } from '@styles';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100vw;
  height: 800px;

  background-color: ${Colors.white};

  @media screen and (max-width: ${MAX_WIDTH_MOBILE}px) {
    display: block;

    width: auto;
    height: auto;
    padding: 70px 30px;
    padding-bottom: 354px;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 1170px;

  @media screen and (max-width: ${MAX_WIDTH_MOBILE}px) {
    position: relative;
    flex-wrap: wrap-reverse;
    justify-content: initial;

    width: auto;
    row-gap: 47px;
  }
`;

export const CycleImg = styled.img`
  width: 266px;
  height: 314px;
  margin-top: 105.5px;

  @media screen and (max-width: ${MAX_WIDTH_MOBILE}px) {
    position: absolute;
    top: 456px;
    right: 0px;

    width: 174px;
    height: 206px;
    margin-top: 0px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextRow = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${MAX_WIDTH_MOBILE}px) {
    flex-direction: column;
  }
`;

export const TextMargin = styled.div`
  margin-top: 20px;
`;
